<template>
  <div class="page">
    <div class="con">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item>自研自创</van-swipe-item>
        <van-swipe-item>独立开发</van-swipe-item>
        <van-swipe-item>新品上市</van-swipe-item>
        <van-swipe-item>创新模式</van-swipe-item>
      </van-swipe>
      <div class="item_warpper">
        <div class="item_con" v-for="(item, index) in itemList" :key="index">
          <img :src="item.src" />
          <div class="tip">{{ item.text }}</div>
        </div>
      </div>
      <div class="flow">
        <div class="title">严控流程</div>
        <van-steps :active="4" class="flow_con">
          <van-step>项目启动</van-step>
          <van-step>系统开发</van-step>
          <van-step>测试修改</van-step>
          <van-step>上线运营</van-step>
        </van-steps>
      </div>
    </div>
    <div class="foot" @click="footHandle()">宁ICP备2021001933号-1</div>
  </div>
</template>

<script>
import Vue from "vue";
import { Swipe, SwipeItem, Lazyload } from "vant";
import { Step, Steps } from "vant";
import util from '@/utils';

Vue.use(Step);
Vue.use(Steps);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Lazyload);
export default {
  data() {
    return {
      images: [
        "https://img01.yzcdn.cn/vant/apple-1.jpg",
        "https://img01.yzcdn.cn/vant/apple-2.jpg",
      ],
      itemList: [
        {
          src: "https://www.irzhd.com//imgs/hxyw%20(5).png",
          text: "全平台软件开发，私有化定制，打造符合客户的软件平台",
        },
        {
          src: "https://www.irzhd.com//imgs/hxyw%20(4).png",
          text: "业内主流工业管理解决方案，多系统协调配合，实现多子公司、多部门、多合作的商业模式",
        },
      ],
    };
  },
  created(){
    const id = util.getUrlParamByName('id');
    document.title="个人建站测试"
    if(id){
      const host = process.env.VUE_APP_QR_API
      location.href = host + "/report?id="+id;
    }
  },
  methods: {
    footHandle() {
      location.href = "https://beian.miit.gov.cn";
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  overflow: hidden;
  .logo {
    width: 200px;
    height: 200px;
    margin-top: 100px;
  }
  .con {
    flex: 1;
  }
  .foot {
    font-size: 14px;
    color: #1989fa;
    margin-bottom: 34px;
    text-align: center;
  }
}
.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  line-height: 150px;
  text-align: center;
  background-color: #39a9ed;
}
.item_warpper {
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
  margin: 20px;
  .item_con {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    min-height: 200px;
    // background: #39a9ed;
    border-radius: 8px;
    padding: 12px;
    img {
      width: 48px;
      height: 48px;
      border-radius: 50%;
    }
    .tip {
      font-size: 14px;
      text-align: justify;
      color: #fff;
    }
    & + .item_con {
      margin-left: 12px;
    }
  }
}
.flow{
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #39a9ed;
  padding: 20px;
  .title{
    font-size: 20px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 14px;
  }
  .flow_con{
    width: 100%;
    background: #39a9ed;
  }
}
</style>